import { Measurement } from "modules/common/components/Alarms/constants";
import { buildBaseAlarmPayload } from "modules/common/components/Alarms/Form/utils/BuildAlarmPayload";
import { IAlarmGroup, SelectedCountyStation, IStationAlarm, StationMeasurementConflict } from "modules/common/components/Alarms/types/AlarmModels";
import { StationType } from "modules/common/components/Alarms/types/AlarmsForm";
import { toast } from "react-toastify";

export const onSubmitValidation = (
    groupName: string,
    alarmGroups: IAlarmGroup[] | null,
    alarmGroupModalData: IAlarmGroup | null,
    countiesStations: SelectedCountyStation[],
    measurements: Measurement[]
) => {
    const filteredAlarmGroups = alarmGroups?.filter(alarm => alarm.id !== alarmGroupModalData?.id);

    const nameAlreadyExists = filteredAlarmGroups?.some(
        alarm =>
            alarm.name.toLowerCase() === groupName.toLowerCase() &&
            alarm.id !== alarmGroupModalData?.id
    );

    if (nameAlreadyExists) {
        toast.error("Grupa alarma s ovim nazivom već postoji.");
        return;
    }

    const conflicts: StationMeasurementConflict[] = [];

    for (const cs of countiesStations) {
        for (const m of measurements) {
            let matchingSma: IStationAlarm | undefined;
            outer: for (const alarmDef of filteredAlarmGroups || []) {
                for (const sma of alarmDef.stationAlarms) {
                    const sameStation =
                        cs.stationType === StationType.Metos
                            ? sma.metosStationId === cs.stationId
                            : sma.pinovaStationId === cs.stationId;
                    const sameMeasurement = sma.measurementType === m.measurementType;
                    if (sameStation && sameMeasurement) {
                        matchingSma = sma;
                        break outer;
                    }
                }
            }

            if (!matchingSma) continue;

            const stationName =
                matchingSma.metosStation?.name ??
                matchingSma.pinovaStation?.name ??
                (cs as any).stationName ??
                `ID:${cs.stationId}`;

            conflicts.push({
                stationName,
                measurementType: m.measurementType,
            });
        }
    }

    const unique = conflicts.filter(
        (c, i, arr) =>
            arr.findIndex(
                x => x.stationName === c.stationName && x.measurementType === c.measurementType
            ) === i
    );

    if (unique.length) {
        const lines = [
            "Alarm već postoji za:",
            ...unique.map(c => `• stanicu "${c.stationName}" i mjerenje "${c.measurementType}"`),
        ];
        const message = lines.join("\n");

        toast.error(message, {
            style: { whiteSpace: "pre-line" },
        });
        return;
    }

    const result = buildBaseAlarmPayload(measurements, countiesStations, groupName, alarmGroupModalData ?? undefined);

    if (!result.payload) {
        toast.error(result.errorMessage || "Provjerite podatke grupe alarma.");
        return;
    }

    return result.payload;
};
